<!-- eslint-disable vue/max-lines-per-block -->
<template>
  <Container class="mt-12 flex items-start">
    <menu class="sticky -left-8 top-24 mr-6 w-24">
      <ClientOnly>
        <ul class="flex flex-col gap-2 text-center">
          <li
            v-for="section, index in sections"
            :key="index"
          >
            <NuxtLink
              class="block p-2 text-xs font-semibold typo-subtitle-sm hover:bg-primary-900/60"
              :class="{ 'bg-primary-900 text-white': route.hash === `#${section}` }"
              :to="`#${section}`"
            >
              {{ section }}
            </NuxtLink>
          </li>
        </ul>
      </ClientOnly>
    </menu>
    <div class="space-y-12 px-12">
      <!-- COLORS -->
      <div
        id="colors"
        class=""
      >
        <h2 class="pb-2 typo-heading-lg">
          Colors
        </h2>
        <hr>
        <div class="flex flex-wrap gap-x-20 gap-y-12 pt-6">
          <div
            v-for="colorGroup, index in theme.colors"
            :key="index"
          >
            <template v-if="typeof colorGroup === 'string'">
              <div
                class="size-24 rounded-full outline outline-1 outline-[#eeeeee]"
                :style="`background: ${colorGroup}`"
              />
              <div class="mt-4 text-center font-semibold typo-body-sm">
                {{ index }}
              </div>
              <div
                v-if="theme"
                class="text-center text-grey-300 typo-subtitle-sm"
              >
                {{ colorGroup }}
              </div>
            </template>
            <template v-else-if="index !== 'theme'">
              <h3 class="pb-4 pt-8 font-semibold typo-h5">
                {{ index }}
              </h3>
              <div class="mt-8 flex flex-wrap justify-start gap-x-12 gap-y-8 px-2">
                <div
                  v-for="(color, code) in colorGroup"
                  :key="color"
                >
                  <div
                    class="size-24 rounded-full outline outline-1 outline-[#eeeeee]"
                    :style="`background: ${color}`"
                  />
                  <div class="mt-4 text-center font-semibold typo-body-sm">
                    {{ code }}
                  </div>
                  <div
                    v-if="theme"
                    class="text-center text-grey-300 typo-subtitle-sm"
                  >
                    {{ color }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- TYPOGRAPHY -->
      <div
        id="typography"
        class="typo-heading-lg"
      >
        <h2 class="pb-2">
          Typography
        </h2>
        <hr>
        <div
          v-for="(size, index) in theme.fontSize"
          :key="index"
          :class="`typo-${index}`"
        >
          {{ index }}
        </div>
      </div>

      <!-- ICONS -->
      <div
        id="icons"
        class=""
      >
        <h2 class="pb-2 font-semibold typo-heading-lg">
          Icons
        </h2>
        <hr>
        <div class="mt-8 flex flex-wrap gap-10">
          <div
            v-for="(iconName, index) in iconNames"
            :key="index"
            class="flex flex-col items-center"
          >
            <component
              :is="iconName"
              class="size-8"
            />
            <div class="mt-4 text-grey-300 typo-body-sm">
              {{ iconName }}
            </div>
          </div>
        </div>
      </div>

      <!-- BUTTONS -->
      <div
        id="buttons"
        class="space-y-5"
      >
        <h2 class="pb-2 font-semibold typo-heading-lg">
          Buttons
        </h2>
        <hr>
        <div class="flex gap-10 p-5">
          <AppButton variant="primary">
            primary
          </AppButton>
          <AppButton
            to="/"
            variant="primary"
          >
            primary
          </AppButton>
          <AppButton
            variant="primary"
            disabled
          >
            disabled
          </AppButton>

          <AppButton
            variant="primary"
            icon="none"
            is-loading
          >
            primary
          </AppButton>
        </div>

        <div class="flex gap-10 p-5">
          <AppButton
            variant="primary"
            size="sm"
          >
            primary
          </AppButton>
          <AppButton
            to="/"
            variant="primary"
            size="sm"
          >
            primary
          </AppButton>
          <AppButton
            variant="primary"
            size="sm"
            disabled
          >
            disabled
          </AppButton>
          <AppButton
            variant="primary"
            icon="none"
            size="sm"
            is-loading
          >
            primary
          </AppButton>
        </div>

        <div class="flex gap-10 bg-blue-500 p-5">
          <AppButton variant="outlined">
            outlined
          </AppButton>

          <AppButton
            variant="outlined"
            disabled
          >
            disabled
          </AppButton>
        </div>

        <div class="flex gap-10 bg-sand-200 p-5">
          <AppButton
            variant="outlined-dark"
            icon="download"
          >
            outlined dark
          </AppButton>
          <AppButton

            variant="outlined-dark"
            disabled
          >
            disabled
          </AppButton>
        </div>

        <div class="flex gap-10 p-5">
          <AppLink to="/">
            outlined dark
          </AppLink>
          <AppLink
            to="/"
            disabled
          >
            disabled
          </AppLink>
        </div>
      </div>

      
    </div>
  </Container>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

import resolveConfig from 'tailwindcss/resolveConfig'
import twConfig from '../tailwind.config'

const { theme } = resolveConfig(twConfig)

const router = useRouter()

const iconNames = ['IconArrowDown', 'IconArrowLink', 'IconArrowLinkBubble', 'IconBurger', 'IconCalendar', 'IconChevron', 'IconDownload', 'IconPlay', 'IconPlus', 'IconMagnifyingGlass', 'IconQuote', 'IconReset', 'IconSpin']

const route = useRoute()

const sections = [
  'colors',
  'typography',
  'icons',
  'buttons',
]
</script>
